// TSS vite/03 §"Query keys convention".
// Tuples, entity-name first, scope narrowing rightward. El recurso es
// public/stats (bloques por view: kpi | report | full).

export const statsKeys = {
    all:  ['stats'],
    view: (view, params) => ['stats', view, params],
};
